<script lang="ts">
    import { List, ListInput, ListItem, Button } from 'framework7-svelte';
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n'; 
    
    import {projectStore} from "../stores/project.store";
    import type {MeasurementSettingsRequest} from "../types/requests/measurement-settings-request.type";
    import type {Project} from "../types/project.type";

    const items = ['here-routing', 'here-traffic', 'ndw-intensity', 'mapbox-congestion']; // keep this names the same because they're also used as labels
    const dispatch = createEventDispatcher();
    
    let values: { [key: string]: string } = {};
    let mapboxZoomLevel: number;
    let hereFunctionalClass: number;
    
    $: if(!$projectStore.loading && $projectStore.data){
        loadValues($projectStore.data);
    }

    function loadValues(project: Project) {
        values = {
            ['here-routing']: (project.hereRoutingInterval ?? 0).toString(),
            ['here-traffic']: (project.hereTrafficInterval ?? 0).toString(),
            ['ndw-intensity']: (project.ndwIntensityInterval ?? 0).toString(),
            ['mapbox-congestion']: (project.mapboxCongestionInterval ?? 0).toString()
        };
    }

    function setValue(item: string, e: CustomEvent) {
        const v = e.detail[0].srcElement.value;
        values[item] = v;
    }

    async function commit() {
        const request: MeasurementSettingsRequest = {
            projectId: $projectStore.data.id,
            mapboxZoomLevel: mapboxZoomLevel || 13,
            hereTrafficFunctionClass: Number.isFinite(hereFunctionalClass) && hereFunctionalClass !== 0 ? hereFunctionalClass : 5,
            hereRoutingInterval: parseInt(values['here-routing']),
            hereTrafficInterval: parseInt(values['here-traffic']),
            ndwIntensityInterval: parseInt(values['ndw-intensity']),
            mapboxCongestionInterval: parseInt(values['mapbox-congestion'])
        };
        
        dispatch('changed', request);
    }
</script>

<div class="margin">
    <div class="title">{$_("measurements.MEASUREMENT_INTERVALS")}</div>
    <List>
        {#each items as item}
            <ListInput type="select" value={values[item]} label={item} on:input={(e) => setValue(item, e)} outline>
                <option value="0">
                    {$_("measurements.DONT_MEASURE")}
                </option>
                <option value="1">
                    {$_("measurements.EVERY_MINUTE")}
                </option>
                <option value="2">
                    {$_("measurements.EVERY_TWO_MINUTES")}
                </option>
                <option value="5">
                    {$_("measurements.EVERY_FIVE_MINUTES")}
                </option>
                <option value="10">
                    {$_("measurements.EVERY_TEN_MINUTES")}
                </option>
                <option value="15">
                    {$_("measurements.EVERY_FIFTEEN_MINUTES")}
                </option>
                <option value="20">
                    {$_("measurements.EVERY_TWENTY_MINUTES")}
                </option>
                <option value="30">
                    {$_("measurements.EVERY_THIRTY_MINUTES")}
                </option>
                <option value="60">
                    {$_("measurements.EVERY_HOUR")}
                </option>
            </ListInput>
        {/each}

        <ListInput
            type="select"
            value={Number.isFinite(hereFunctionalClass) && hereFunctionalClass !== 0 ? hereFunctionalClass?.toString() : '5'}
            label={$_("measurements.HERE_FUNCTIONAL_CLASS")}
            on:input={(v) => (hereFunctionalClass = parseInt(v.detail[0].srcElement.value))}
            outline
            required
        >
            <option value="1">
                {$_("measurements.HERE_FUNCTIONAL_CLASS_1")}
            </option>
            <option value="2">
                {$_("measurements.HERE_FUNCTIONAL_CLASS_2")}
            </option>
            <option value="3">
                {$_("measurements.HERE_FUNCTIONAL_CLASS_3")}
            </option>
            <option value="4">
                {$_("measurements.HERE_FUNCTIONAL_CLASS_4")}
            </option>
            <option value="5">
                {$_("measurements.HERE_FUNCTIONAL_CLASS_5")}
            </option>
        </ListInput>

        <ListInput
            required
            type="select"
            value={mapboxZoomLevel?.toString() || '13'}
            label={$_("measurements.MAPBOX_ZOOM_LEVEL")}
            on:input={(v) => (mapboxZoomLevel = parseInt(v.detail[0].srcElement.value))}
            outline
        >
            <option value="11">
                {$_("measurements.MAPBOX_ZOOM_LEVEL_11")}
            </option>
            <option value="12">
                {$_("measurements.MAPBOX_ZOOM_LEVEL_12")}
            </option>
            <option value="13">
                {$_("measurements.MAPBOX_ZOOM_LEVEL_13")}
            </option>
        </ListInput>

        <ListItem>
            <Button popupClose on:click={commit} fill>
                {$_("shared.SAVE")}
            </Button>
            <Button popupClose>
                {$_("shared.CANCEL")}
            </Button>
        </ListItem>
    </List>
</div>
